module.exports = __webpack_public_path__ + "static/26-e0df7d9976d24a36ea0d9aa6270c87a6.jpg";